import defaultSettings from '../defaultSettings';
import { useCallback, useMemo, useState } from 'react';

const getRangeSettings = (key) => {
  const fromLS = localStorage.getItem(key);

  if (fromLS) {
    try {
      const parsed = JSON.parse(fromLS);

      if (typeof parsed === 'object' && parsed !== null) {
        return parsed;
      }
    } catch (e) {}
  }

  if (defaultSettings[key]) {
    return defaultSettings[key];
  }

  return {
    min: 0,
    max: 100,
    step: 1,
  };
};

const useRangeSettings = (key) => {
  const realKey = useMemo(() => {
    const parts = key.split('.');

    if (parts[0] === 'presets') {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const [p0, p1, ...rest] = parts;

      return [p0, ...rest].join('.');
    }

    return key;
  }, [key]);

  const [range, localSetRange] = useState(getRangeSettings(realKey));

  const setRange = useCallback(
    (newValues) => {
      const normalized = {
        min: parseFloat(newValues.min),
        max: parseFloat(newValues.max),
        step: parseFloat(newValues.step),
      };

      localSetRange(normalized);

      localStorage.setItem(realKey, JSON.stringify(normalized));
    },
    [realKey]
  );

  return [range, setRange];
};

export default useRangeSettings;
